import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cigna-cafooter-unsecure',
  templateUrl: './footer-unsecure.component.html',
  styleUrls: ['./footer-unsecure.component.scss'],
})
export class FooterUnSecureComponent implements OnInit {
  currentYear = new Date().getFullYear().toString();

  ngOnInit() {}
}
